import type { Action } from 'svelte/action'

type LinkAction = (node: HTMLAnchorElement) => void | { destroy?: () => void }

// What a link rendered by a shared component (Button, IconButton) does on click. A plain <a> by default, which
// Unpoly follows; the Inertia app installs its `inertia` action at boot. Injected rather than imported so that
// the Unpoly bundles don't pull in @inertiajs.
let currentAction: LinkAction = () => {}

export function setLinkAction(action: LinkAction): void {
  currentAction = action
}

export const linkAction: Action<
  HTMLAnchorElement,
  undefined,
  { onbefore?: (event: Event) => void }
> = (node) => {
  const { destroy } = currentAction(node) ?? {}
  return { destroy }
}
